var React = require('react');

function CopyInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4.666 6.335L2.747 8.253c-.53.53-.8 1.275-.753 2.071.048.796.41 1.58 1.007 2.176.596.597 1.379.958 2.175 1.006.797.047 1.542-.223 2.071-.753l1.919-1.918m1.169-1.17l1.918-1.918c.53-.53.8-1.275.753-2.071-.047-.796-.41-1.58-1.006-2.176-.597-.596-1.38-.958-2.176-1.006-.796-.047-1.541.224-2.07.753L5.834 5.166m3.442 1.058l-3.75 3.75","stroke":"#172138","strokeMiterlimit":"10"}));
}

CopyInline.defaultProps = {"viewBox":"0 0 15 16","fill":"none"};

module.exports = CopyInline;

CopyInline.default = CopyInline;
